import { useRef, useState, useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { triggerLogin } from '../api/Auth.api';
import { decodeToken } from '../functions/helper';
import useAuth from '../hooks/useAuth';
import Loading from "../components/Loading";

const Login = () => {
  const emailRef = useRef();
  const errRef = useRef();

  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isPersist, setIsPersist] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const { handleAuthentication, handlePersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    emailRef.current.focus();
  }, [])

  useEffect(() => {
    setErrMsg('');
  }, [email, password])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);

    try {
      const response = await triggerLogin({ email, password });

      const token = response.token;
      const refresh = response.refreshToken;

      const jwt = decodeToken(token);

      // Check if user is active before allowing login
      if (!jwt.is_active) {
        setErrMsg('Your account has been temporarily deactivated. Please call the office on 08 9203 1272 for further information');
        return;
      }

      handleAuthentication({ ...jwt, token: token, refresh_token: refresh });
      handlePersist(isPersist ? 1 : 0);
      handleReset();

      setTimeout(() => {
        navigate(from, { replace: true });
      }, 100);
    } catch (err) {
      console.log(err)

      if (!err?.response) return setErrMsg('No Server Response');
      if (err.response?.status === 400) return setErrMsg('Missing Username or Password');
      if (err.response?.status === 401) return setErrMsg('Unauthorized');

      setErrMsg("Login Failed\n" + err.response?.data.message);
    }

    finally {
      setIsLoggingIn(false);
    }

  }

  const handleTogglePersist = (value) => {
    setIsPersist(value);
  }

  const handleReset = () => {
    setEmail('');
    setPassword('');
  }

  if (isLoggingIn) return <Loading />;

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="shadow login-box text-center border rounded p-4" style={{ maxWidth: '400px' }}>
        <p ref={errRef} className={errMsg ? "alert alert-danger" : "offscreen"} aria-live="assertive">
          {errMsg}
        </p>

        <h1>Sign In</h1>
        <form onSubmit={handleSubmit}>
          <Row className="mb-4">
            <Col>
              <TextField
                type="email"
                label="Email"
                id="email"
                ref={emailRef}
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
              />
            </Col>
          </Row>

          <Row className="mb-4">
            <Col>
              <TextField
                type='password'
                label="Password"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
              />
            </Col>
          </Row>

          <div className="persistCheck mb-4">
            <input
              type="checkbox"
              id="persist"
              onChange={(e) => handleTogglePersist(e.target.checked)}
              value={isPersist}
            />
            <label htmlFor="persist">Trust This Device</label>
          </div>
          <Button size="large" variant="contained" type="submit" loading={isLoggingIn}>Log in</Button>
        </form>
      </div>
    </div>
  );
}

export default Login;